import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import { useApiClient } from 'src/common/providers'
import { ListAndCount } from 'src/common/types'
import { getUTCDate } from 'src/common/utils'

import type { SearchBatchesFuncType, SearchStatsFilterType } from './lib'
import {
  Entity,
  FuncSort,
  getFuncByEntity,
  hasPropertyAndNotNull,
  placeholderData,
} from './lib'

export default function useSearchBatches(
  filter: SearchStatsFilterType,
  enabled = true,
  extraOptions?: Partial<UseQueryOptions>
): Readonly<
  UseQueryResult<ListAndCount<typeof Entity.BatchesStatus>, unknown>
> {
  const { apiClient } = useApiClient()
  const func = getFuncByEntity(
    FuncSort.search,
    Entity.BatchesStatus
  ) as SearchBatchesFuncType
  const queryResult = useQuery({
    queryKey: [filter.auctionDate, filter.locationCode],
    enabled:
      enabled &&
      Boolean(apiClient) &&
      Boolean(filter) &&
      hasPropertyAndNotNull(apiClient, func),
    keepPreviousData: true,
    placeholderData,
    queryFn: () =>
      apiClient[func](
        getUTCDate(new Date(filter.auctionDate)),
        filter.locationCode,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      ) as Promise<typeof Entity.BatchesStatus>,
    select: (result: any) => ({
      records: result?.value || [],
      count: result['@odata.count'] ?? 0,
    }),
    ...extraOptions,
  }) as UseQueryResult<ListAndCount<typeof Entity.BatchesStatus>, unknown>

  return queryResult
}
